import { AlertMedia, CameraAlertMedia, ImageVideoTuple, TimestampCameraMedia } from "./types/alert";


export const groupAlertsByTimestampCameraId = (media: AlertMedia[]) => {
    const groupByTimestamp: Record<string, Record<string, ImageVideoTuple>> = {};

    media.forEach((medium: AlertMedia) => {
        if (!groupByTimestamp[medium.mediaTimestamp]) {
            groupByTimestamp[medium.mediaTimestamp] = {};
        }

        if (!groupByTimestamp[medium.mediaTimestamp][medium.cameraId]) {
            groupByTimestamp[medium.mediaTimestamp][medium.cameraId] = {} as any;
        }

        if (medium.mimeType.includes("image")) {
            groupByTimestamp[medium.mediaTimestamp][medium.cameraId].imageMedia = medium;
        }

        if (medium.mimeType.includes("video")) {
            groupByTimestamp[medium.mediaTimestamp][medium.cameraId].videoMedia = medium;
        }
    });

    const arrList: TimestampCameraMedia[] = Object.entries(groupByTimestamp).map((group) => {
        const timestamp = group[0];
        const cameraMedia: CameraAlertMedia[] = Object.entries(group[1]).map(([cameraId, media]) => {
            return {
                cameraId: Number(cameraId),
                media,
            };
        });

        return { timestamp, cameraMediaList: cameraMedia };
    });

    return arrList;
};

export const toMMSS = (secs: number) => {
    const sec_round = Math.round(secs);
    const hours = Math.floor(sec_round / 3600);
    const minutes = Math.floor(sec_round / 60) % 60;
    const seconds = sec_round % 60;

    return [hours, minutes, seconds]
        .map((v) => (v < 10 ? "0" + v : v))
        .filter((v, i) => v !== "00" || i > 0)
        .join(":");
};
